import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { RequirementAction } from "../types";
import { selectorIsRequirementPostApproval } from "../selectors/selectorIsRequirementPostApproval";

export const extendRequirementOnboardingToolbarActions = (
  requirement: IRequirementResponse,
  originalActions: RequirementAction[],
  onClose: () => void
): RequirementAction[] => {
  const isMainActionExist = originalActions.some(
    action =>
      action.mainAction && action.visible !== false && action.hidden !== true
  );

  const isPostApproval = selectorIsRequirementPostApproval(requirement);

  const continueActionAvailable =
    requirement.status !== RequirementStatus.Incomplete &&
    (requirement.status === RequirementStatus.Complete || !isMainActionExist);

  const continueButtonVisible = isPostApproval ? true : continueActionAvailable;
  const closeButtonVisible = continueButtonVisible
    ? false
    : isPostApproval
    ? false
    : requirement.status !== RequirementStatus.Complete;

  const defaultActions: RequirementAction[] = [
    {
      label: "Continue",
      buttonOrder: 0,
      onClick: () => {
        onClose();
      },
      buttonKind: "Primary",
      buttonIcon: null,
      icon: "check",
      visible: continueButtonVisible
    },
    {
      label: "Close",
      onAsyncClick: async () => {
        onClose();
      },
      buttonKind: "Tertiary",
      visible: closeButtonVisible,
      icon: "skip-circle",
      buttonIcon: null
    }
  ];

  if (
    originalActions.filter(
      action => action.visible !== false && action.hidden !== true
    ).length > 2
  ) {
    const visibleMainButtons = originalActions.map(action => ({
      ...action,
      buttonKind:
        action.mainAction && action.visible !== false && action.hidden !== true
          ? action.buttonKind
          : undefined
    }));

    return [...defaultActions, ...visibleMainButtons];
  }

  return [...defaultActions, ...originalActions];
};
